import React from "react";
import styled from "styled-components";
import { useAuth } from "../../context/AuthContext";

const Wrap = styled.div`
  position: relative;
`;

const PreviewWrap = styled.div`
  filter: blur(0);
  pointer-events: none;
  opacity: 0.6;
`;

const Banner = styled.div`
  position: sticky;
  bottom: 24px;
  margin: 48px auto 0;
  max-width: 640px;
  background: var(--nd-surface-raised);
  border: 1px solid var(--nd-border-visible);
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  z-index: 10;
`;

const Label = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-secondary);
`;

const Title = styled.h3`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 22px;
  font-weight: 500;
  color: var(--nd-text-display);
  margin: 0;
`;

const Button = styled.button`
  font-family: 'Space Mono', monospace;
  font-size: 13px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 12px 24px;
  min-height: 44px;
  border-radius: 999px;
  border: none;
  background: var(--nd-text-display);
  color: var(--nd-black);
  cursor: pointer;
  outline: none;
  transition: opacity 250ms cubic-bezier(0.25, 0.1, 0.25, 1);

  &:hover { opacity: 0.85; }
`;

const MailLink = styled.a`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--nd-text-display) !important;
  text-decoration: underline;
`;

const AuthGate = ({ requiredRole, children }) => {
  const { user, signIn } = useAuth();

  return (
    <Wrap>
      {children && <PreviewWrap>{children}</PreviewWrap>}
      <Banner>
        <Label>LOCKED — requires {requiredRole}</Label>
        {!user ? (
          <>
            <Title>Sign in to continue</Title>
            <Button type="button" onClick={signIn}>Continue with Google</Button>
          </>
        ) : (
          <>
            <Title>Request {requiredRole} access</Title>
            <MailLink href={`mailto:hello@dioscuro.com?subject=Access request: ${requiredRole}`}>
              Email hello@dioscuro.com
            </MailLink>
          </>
        )}
      </Banner>
    </Wrap>
  );
};

export default AuthGate;
